<script lang="ts">
    import {duration as durationStore} from 'general/store';

    export let disableInAnimation = false;
    export let delayIn = 1300;

    const opacity = (
        _: Node,
        {duration, direction}: {duration: number; direction: 'in' | 'out'},
    ) => {
        if (disableInAnimation && direction == 'in') return;
        return {
            duration,
            css: (t: number) => {
                return `opacity: ${t};`;
            },
            delay: direction == 'in' ? delayIn : 0,
        };
    };
</script>

<style module>
    .flip {
        position: absolute;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
    }
</style>

<div
    class="flip"
    in:opacity={{duration: $durationStore.opacity.in, direction: 'in'}}
    out:opacity={{duration: $durationStore.opacity.out, direction: 'out'}}
>
    <slot />
</div>
